export default "__VITE_ASSET__lajTkLIg__"